import type { IconSvgObject } from './types';

const GalleryVerticalEndIcon: IconSvgObject = [
  ["path", { d: "M6 2L18 2", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "0" }],
  ["path", { d: "M4 6L20 6", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "1" }],
  ["path", { d: "M3 20L3 12C3 10.8954 3.89543 10 5 10L19 10C20.1046 10 21 10.8954 21 12V20C21 21.1046 20.1046 22 19 22L5 22C3.89543 22 3 21.1046 3 20Z", stroke: "currentColor", strokeLinecap: "round", strokeLinejoin: "round", strokeWidth: "1.5", key: "2" }]
];

export default GalleryVerticalEndIcon;
